export const rolePermission = {
    roleView: "role.view",
    rolesCreate: "roles.create",
    roleUpdate: "role.update",
    roleDelete: "role.delete"
};
